module.exports = __webpack_public_path__ + "static/media/award.dc39660f.png";